<div class="row">
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0 text-nowrap">
        <thead class="text-center">
            <tr>
                <th>
                    시간
                </th>
                <th>
                    누적운행거리(km)
                </th>
                <th>
                    트립운행거리(km)
                </th>
                <th>
                    속도(km/h)
                </th>
                <th>
                    RPM
                </th>
                <th>
                    트립연료사용량(L)
                </th>
                <th>
                    온도1(°C)
                </th>
                <th>
                    온도2(°C)
                </th>
                <th>
                    위치
                </th>
            </tr>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listTeam;">
                <td>
                    {{item.dtgRegDt}}
                </td>
                <td class="text-right">
                    {{item.dtgDistAccumul | filterDist | number:'0.0-3'}}
                </td>
                <td class="text-right">
                    {{item.dtgDistTrip | filterDist | number:'0.0-3'}}
                </td>
                <td class="text-right">
                    {{item.dtgSpeed | number}}
                </td>
                <td class="text-right">
                    {{item.dtgRpm | number}}
                </td>
                <td class="text-right">
                    {{item.dtgOilUseTrip | filterDist | number:'0.0-3'}}
                </td>
                <td class="text-right">
                    {{(item.dtgTemper1 * 0.1) | number:'0.0-1'}}
                </td>
                <td class="text-right">
                    {{(item.dtgTemper2 * 0.1) | number:'0.0-1'}}
                </td>
                <td>
                    {{item.dtgGpsAddr || '-'}}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>